import { addressToString } from '@aloft/toolkit-shared';

import { useMetadataByID } from '../../../controller/hooks/useMetadataByID.ts';
import { formatReferenceViewID } from '../referenceViewID/formatReferenceViewID.ts';
import { isReferenceViewPropertyIDParsed } from '../referenceViewID/isReferenceViewPropertyIDParsed.ts';
import { parseReferenceViewID } from '../referenceViewID/parseReferenceViewID.ts';

export type AddressByPropertyID = { [index: string]: string };
export function useAddressesByPropertyID(): AddressByPropertyID {
  const metadataByID = useMetadataByID();

  const addresses: AddressByPropertyID = {
    subject: addressToString(
      metadataByID[formatReferenceViewID({ type: 'subject' })]?.address || {},
    ),
  };

  Object.entries(metadataByID).forEach(([id, metadata]) => {
    const parsed = parseReferenceViewID(id);
    if (parsed && isReferenceViewPropertyIDParsed(parsed) && parsed.type === 'comparable') {
      addresses[parsed.compID] = addressToString(metadata.address ?? {});
    }
  });

  return addresses;
}
